/*
 * @Author       : shenqing
 * @desc         : 组件描述
 * @Date         : 2024-07-18 14:13:47
 * @LastEditTime : 2025-11-27 10:45:12
 * @LastEditors  : QLing
 * @FilePath     : /evalute-all/teaching_QualityService/src/api/all.js
 */
import { http } from './http.js'
let api = {
    //非敏感信息
    notSensitiveConfig: param => {
        return http.get('/notSensitiveConfig', param, 'count')
    },
    // 枚举
    GET_ENUMS: param => {
        return http.get(`/enums/${param.name}`, param)
    },
    // 查询课程列表（用于单个课程分析）
    analysisCourses: param => {
        return http.get(`/teaching/analysis/courses`, param)
    },
    // 单个课程分析条件查询
    singleConditions: param => {
        return http.get(`/teaching/analysis/single/conditions`, param)
    },
    // 设置分析条件
    conditions: param => {
        return http.post(`/teaching/analysis/set/conditions`, param)
    },
    // 单个课程分析列表
    singleInfo: param => {
        return http.get(`/teaching/analysis/single/info`, param)
    },
    // 多个课程分析条件查询
    multipleConditions: param => {
        return http.get(`/teaching/analysis/multiple/conditions`, param)
    },
    // 多个课程分析列表
    multipleInfo: param => {
        return http.get(`/teaching/analysis/multiple/info`, param)
    },
    // 学期教学概况——考勤
    attend: param => {
        return http.get(`/teaching/analysis/term/attend&interact`, param)
    },
    // 学期教学概况——教学互动
    interact: param => {
        return http.get(`/teaching/analysis/term/interact`, param)
    },
    // 学期教学概况——授课信息、被评信息、被评得分
    teaching: param => {
        return http.get(`/teaching/analysis/term/teaching`, param)
    },
    // 诊改报告获取学年学期
    treatmentsTerms: param => {
        return http.get(`/treatments/terms`, param)
    },

    // 获取诊改报告列表
    treatmentsUsers: param => {
        return http.get(`/treatments/users/${param.userCode}`, param)
    },
    // 获取诊改报告
    treatments: param => {
        return http.get(`/treatments/${param.treatmentCode}`, param)
    },
    // 提交诊改报告
    treatmentsSet: param => {
        return http.post(`/treatments/set`, param)
    },
    // 获取诊改报告接点数据
    treatmentsNodes: param => {
        return http.get(`/treatments/${param.treatmentCode}/nodes`, param)
    },
    // 保存诊改报告节点
    treatmentsNodesSave: param => {
        return http.post(`/treatments/nodes`, param)
    },
    // 特殊诊断点
    treatmentsAchievements: param => {
        return http.get(`/treatments/achievements`, param)
    },
    // 特殊诊断点——获取学生评教
    studentEvaluateInfo: param => {
        return http.get(`/treatments/studentEvaluateInfo`, param)
    },
    // 特殊诊断点——督导领导评教
    teacherEvaluateInfo: param => {
        return http.get(`/treatments/teacherEvaluateInfo`, param)
    },
    // 培养层次
    enumsEducationalLevelEnum: param => {
        return http.get(`/enums/dict`, param)
    },
    // 个人中心——个人信息
    userMsg: param => {
        // 获取个人信息
        return http.get(`/teachers/${param.userCode}/info/pc`, param)
    },
    tchChart: param => {
        // 教师 获取统计信息
        return http.get(`/teachers/${param.userCode}/info/tch/chart`, param)
    },
    leaderChart: param => {
        // 督导 获取统计信息
        return http.get(`/teachers/${param.userCode}/info/leader/chart`, param)
    },
    // 个人中心——我收到的评价
    staffEvaluate: param => {
        // 教职工对我的评价
        return http.get('/receiveevaluate/staffEvaluate', param)
    },
    staffEvaluateList: param => {
        // 学生对我的评价
        return http.get('/receiveevaluate/studentEvaluate/list', param)
    },
    studentEvaluatePce: param => {
        // 学生对我的评价——详情
        return http.get(`/receiveevaluate/studentEvaluate/pce/${param.pceCode}`, param)
    },
    staffEvaluateTch: param => {
        // 教职工对我的评价——详情
        return http.get(`/receiveevaluate/staffEvaluate/evaluates/${param.evaluateCode}`, param)
    },
    setConfirmReadStatus: param => {
        // 教职工对我的评价——详情
        return http.get(`/receiveevaluate/setConfirmReadStatus/${param.evaluateCode}`, param)
    },
    readButtonShow: param => {
        // 教职工对我的评价——详情
        return http.get(`/receiveevaluate/readButtonShow`, param)
    },
    courseListByTeacher: param => {
        // 教师——查询课程列表
        return http.get(`/littleNote/courseListByTeacher`, param)
    },
    littleNoteByTeacher: param => {
        // 教师——小纸条列表
        return http.get(`/littleNote/littleNoteByTeacher`, param)
    },
    littleNoteReply: param => {
        // 教师——小纸条回复
        return http.post(`/littleNote/littleNoteReply`, param)
    },
    littleNoteReplyDel: param => {
        // 教师——小纸条删除
        return http.post(`/littleNote/delete/littleNoteReply/${param.replyCode}/${param.sendCode}`, param)
    },
    task: param => {
        // 我的评价任务
        return http.get(`/task/page/detail/${param.localUserCode}`, param)
    },
    group: param => {
        // 消息类型筛选
        return http.get(`/message/list/group/PC`, param)
    },
    // 消息列表
    messageList: param => {
        return http.get(`/message/list/PC`, param)
    },
    // 删除消息
    delMessage: param => {
        return http.post(`/message/delete`, param)
    },
    // 消息详情
    messageDetail: param => {
        return http.get(`/message/messageInfo/${param.messageCode}`, param)
    },
    // 全部设为已读
    allRead: param => {
        return http.post(`/message/set/read`, param)
    },
    // 是否有未读消息
    hasReadNotMessage: param => {
        return http.get(`/message/hasReadNotMessage`, param)
    },
    // 获取分数展示
    allocation: param => {
        return http.get(`/eval/common/system/rule/all`, param)
    },
    // 获取分数展示
    starShow: param => {
        return http.get(`/receiveevaluate/evalScoreStarShowRule`, param)
    },
    studentEvaluateCourseList: param => {
        // 4.5 学生对我的评价 - 按课表查看
        return http.get(`/receiveevaluate/studentEvaluate/courseList`, param)
    },
    studentEvaluateCourseScore: param => {
        // 4.5 学生对我的评价 - 按课表查看 - 评价得分
        return http.get(`/receiveevaluate/studentEvaluate/courseScore`, param)
    },
    studentEvaluateImageInfo: param => {
        // 4.5 学生对我的评价 - 评价图片加载信息
        return http.get(`/receiveevaluate/studentEvaluate/imageInfo`, param)
    },
    preferedevaluate: param => {
        // 4.3.0 - 首选展示评价类型
        return http.get(`/common/preferedevaluate`, param)
    },
    //  获取当前学年学期、周次
    terms: param => {
        // 今日全校出勤率 及 学期出勤率
        return http.get(`/term/week&day`, param, 'moni')
    },
    termsInfo: param => {
        // 查询当前学年学期，及其过去num个学年学期
        return http.get(`/term/info`, param, 'moni')
    },
    getCampusList: param => {
        // 获取校区
        return http.get(`/campus/getCampusList`, param, 'moni')
    },
    getDepartment: param => {
        // 获取学院
        return http.get(`/department/list/department`, param, 'moni')
    },
    getDepartmentWeekAndtream: param => {
        // 针对周和学期获取学院（教学运行状态）
        return http.get(`/common/org/info`, param, 'moni')
    },
    getSystemConfig: param => {
        // 用于获取系统配置，判断在课堂监控页面是否展示评价按钮
        return http.get(`/common/getSystemConfig`, param, 'moni')
    },
    // 监控-教学运行状态-每天
    dayAttendPer: param => {
        // 今日全校出勤率 及 学期出勤率
        return http.get(`/situation/day/attend/per`, param, 'moni')
    },
    dayClassAndstu: param => {
        // 今日点名班课、今日到课学生
        return http.get(`/situation/day/class&stu`, param, 'moni')
    },
    dayEarlyWarning: param => {
        // 今日预警班级、今日预警学生
        return http.get(`/situation/day/early/warning`, param, 'moni')
    },
    situationTimetableBullet: param => {
        // 弹幕数据
        return http.get(`/bullet/all/condition/`, param, 'moni')
    },
    dayTimetableAttend: param => {
        // 今日节次出勤率趋势
        return http.get(`/situation/day/timetable/attend`, param, 'moni')
    },
    dayTimetableAttendExport: param => {
        // 今日节次出勤率趋势导出
        return http.get(`/situation/day/timetable/attend/export`, param, 'moni')
    },
    // 获取节次
    dayTimetableAttendclassroom: param => {
        // 教室使用状态
        return http.get(`/situation/day/classroom/getClassRoomScheduleCourse`, param, 'moni')
    },
    daySectionClassRoomUtilization: param => {
        // 教室使用状态头部信息
        return http.get(`/classRoomState/getSectionClassRoomUtilization`, param, 'moni')
    },
    // 获取节次
    dayCurrentSection: param => {
        return http.get(`/term/getCurrentSection`, param, 'moni')
    },
    // 楼层列表
    GetBuildingFloortion: param => {
        return http.get(`/classRoomState/getBuildingFloor`, param, 'moni')
    },
    // 楼层信息
    GetClassRoomSignRateList: param => {
        return http.get(`/classRoomState/getClassRoomSignRateList`, param, 'moni')
    },
    // 楼层-该教室今日其他课程
    GetclassRoomToDayOtherCourse: param => {
        return http.get(`/classRoomState/classRoomToDayOtherCourse`, param, 'moni')
    },
    // 教学班-头部信息
    GetcourseTimeTableDetailSignInRate: param => {
        return http.get(`/classRoomState/courseTimeTableDetailSignInRate`, param, 'moni')
    },
    // 教学班-课程信息
    GetcourseTimeTableDetailDetail: param => {
        return http.get(`/classRoomState/courseTimeTableDetail`, param, 'moni')
    },
    // 教学班课程-教师收到的评价
    GettEacherReceivedEvaluateDetail: param => {
        return http.get(`/classRoomState/teacherReceivedEvaluate`, param, 'moni')
    },
    // 教学班课程-发起点名、平均出勤率
    GetTeachingClassInteractDetail: param => {
        return http.get(`/classRoomState/teachingClassInteract`, param, 'moni')
    },
    // 教学班课程-查询场所视频流地址
    GetTeachingQueryVideoAddress: param => {
        return http.get(`/placeVideo/queryVideoAddress`, param, 'moni')
    },
    // 教学班课程-场所-教室视频流服务控制器
    GetTeachingQueryPlaceStreamInfo: param => {
        return http.get(`/placeVideo/queryPlaceStreamInfo`, param, 'moni')
    },
    // 教学班课程-场所-教室视频流服务控制器 - 西翻
    GetPlaceVideoXiAnLiveUrls: param => {
        return http.get(`/placeVideo/xiAnLiveUrl/${param.placeCode}`, param, 'moni')
    },
    // 教学班课程-出勤概况
    GetStudentSignInRateListDetail: param => {
        return http.post(`/classRoomState/studentSignInRateList`, param, undefined, 'moni')
    },
    // 教学班课程-教学日历
    GetTeachingClassResourceListDetail: param => {
        return http.get(`/classRoomState/teachingClassResourceList`, param, 'moni')
    },

    dayOrgAttend: param => {
        // 今日各院系出勤率
        return http.get(`/situation/day/org/attend`, param, 'moni')
    },
    // 监控-教学运行状态-每周
    weekAttendInfo: param => {
        // 本周院系出勤率趋势
        return http.get(`/situation/week/attend/info`, param, 'moni')
    },
    weekAttendper: param => {
        // 本周全校出勤率 及 学期出勤率
        return http.get(`/situation/week/attend/per`, param, 'moni')
    },
    weekClassInfo: param => {
        // 本周全校点名班课数
        return http.get(`/situation/week/class/info`, param, 'moni')
    },
    weekSignInfo: param => {
        // 点名班课、点名次数、到课学生
        return http.get(`/situation/week/sign/info`, param, 'moni')
    },
    weekStuAttend: param => {
        // 本周全校到课学生数
        return http.get(`/situation/week/stu/attend`, param, 'moni')
    },
    weekOrgAttend: param => {
        // 本周全校各院系出勤率
        return http.get(`/situation/week/org/attend`, param, 'moni')
    },
    weekEarlyWarning: param => {
        // 本周预警班级、本周预警学生
        return http.get(`/situation/week/early/warning`, param, 'moni')
    },
    // 监控-教学运行状态-每学期
    termAttendInfo: param => {
        // 本学期院系出勤率趋势
        return http.get(`/situation/term/attend/info`, param, 'moni')
    },
    termAttendPer: param => {
        // 本学期全校出勤率 及 学期出勤率
        return http.get(`/situation/term/attend/per`, param, 'moni')
    },
    termSignInfo: param => {
        // 点名班课、点名次数、到课学生
        return http.get(`/situation/term/sign/info`, param, 'moni')
    },
    termClassInfo: param => {
        // 本学期全校点名班课数
        return http.get(`/situation/term/class/info`, param, 'moni')
    },
    termStuAttend: param => {
        // 本学期全校到课学生数
        return http.get(`/situation/term/stu/attend`, param, 'moni')
    },
    termOrgAttend: param => {
        // 本学期全校各院系出勤率
        return http.get(`/situation/term/org/attend`, param, 'moni')
    },
    termEarlyWarning: param => {
        // 本周预警班级、本周预警学生
        return http.get(`/situation/term/early/warning`, param, 'moni')
    },
    // 监控-教学评价状态-每天
    dayAllInfo: param => {
        // 评价概况
        return http.get(`/evaluation/day/all/info`, param, 'moni')
    },
    dayCourseInfo: param => {
        // 教学评教 课程覆盖率
        return http.get(`/evaluation/day/course/info`, param, 'moni')
    },
    dayCoursePer: param => {
        // 教学评教 教师覆盖率
        return http.get(`/evaluation/day/course/per`, param, 'moni')
    },
    dayCourseCompare: param => {
        // 教学评教 课程得分对比
        return http.get(`/evaluation/day/course/compare`, param, 'moni')
    },
    dayTchCompare: param => {
        // 教学评教 教师得分对比
        return http.get(`/evaluation/day/tch/compare`, param, 'moni')
    },
    dayTchFocus: param => {
        // 需要部门关注/部门改进完成 的教师
        return http.get(`/evaluation/day/tch/focus`, param, 'moni')
    },
    dayCourseInfoSub: param => {
        // 教学评教 课程覆盖率 查询课程评教列表
        return http.get(`/evaluation/day/course/info/sub`, param, 'moni')
    },
    dayCoursePerSub: param => {
        // 教学评教 教师覆盖率 查询教师评教列表
        return http.get(`/evaluation/day/course/per/sub`, param, 'moni')
    },
    // 监控-教学评价状态-每周
    weekAllInfo: param => {
        // 评价概况
        return http.get(`/evaluation/week/all/info`, param, 'moni')
    },
    weekCourseInfo: param => {
        // 教学评教 课程覆盖率
        return http.get(`/evaluation/week/course/info`, param, 'moni')
    },
    weekCoursePer: param => {
        // 教学评教 教师覆盖率
        return http.get(`/evaluation/week/course/per`, param, 'moni')
    },
    weekCourseCompare: param => {
        // 教学评教 课程得分对比
        return http.get(`/evaluation/week/course/compare`, param, 'moni')
    },
    weekTchCompare: param => {
        // 教学评教 教师得分对比
        return http.get(`/evaluation/week/tch/compare`, param, 'moni')
    },
    weekTchFocus: param => {
        // 需要部门关注/部门改进完成 的教师
        return http.get(`/evaluation/week/tch/focus`, param, 'moni')
    },
    weekCourseInfoSub: param => {
        // 教学评教 课程覆盖率 查询课程评教列表
        return http.get(`/evaluation/week/course/info/sub`, param, 'moni')
    },
    weekCoursePerSub: param => {
        // 教学评教 教师覆盖率 查询教师评教列表
        return http.get(`/evaluation/week/course/per/sub`, param, 'moni')
    },
    // 监控-教学评价状态-每学期
    termAllInfo: param => {
        // 评价概况
        return http.get(`/evaluation/term/all/info`, param, 'moni')
    },
    termCourseInfo: param => {
        // 教学评教 课程覆盖率
        return http.get(`/evaluation/term/course/info`, param, 'moni')
    },
    termCoursePer: param => {
        // 教学评教 教师覆盖率
        return http.get(`/evaluation/term/course/per`, param, 'moni')
    },
    termCourseCompare: param => {
        // 教学评教 课程得分对比
        return http.get(`/evaluation/term/course/compare`, param, 'moni')
    },
    termTchCompare: param => {
        // 教学评教 教师得分对比
        return http.get(`/evaluation/term/tch/compare`, param, 'moni')
    },
    termTchFocus: param => {
        // 需要部门关注/部门改进完成 的教师
        return http.get(`/evaluation/term/tch/focus`, param, 'moni')
    },
    termCourseInfoSub: param => {
        // 教学评教 课程覆盖率 查询课程评教列表
        return http.get(`/evaluation/term/course/info/sub`, param, 'moni')
    },
    termCoursePerSub: param => {
        // 教学评教 教师覆盖率 查询教师评教列表
        return http.get(`/evaluation/term/course/per/sub`, param, 'moni')
    },
    // 监控-教学互动状态-全校互动按日统计情况控制器
    querySchInteractSituation: param => {
        // 查询全校整体互动情况(日,周,学期)
        return http.get(`/schInteractSituationDay/querySchInteractSituation`, param, 'moni')
    },
    queryTheDayInteractSchoolJoinStuNum: param => {
        // 今日全校参与互动人数
        return http.get(`/orgInteractSituationDay/queryTheDayInteractSchoolJoinStuNum`, param, 'moni')
    },
    queryInteractJoinStuNum: param => {
        // 今日各类互动参与人数(本周,学期)
        return http.get(`/orgInteractSituationDay/queryInteractJoinStuNum`, param, 'moni')
    },
    queryOrgInteractNumber: param => {
        // 各院系互动次数(天,周,学期)
        return http.get(`/orgInteractSituationDay/queryOrgInteractNumber`, param, 'moni')
    },
    queryOrgInteractTypeNumber: param => {
        // 院系各类互动次数(天,周,学期)
        return http.get(`/orgInteractSituationDay/queryOrgInteractTypeNumber`, param, 'moni')
    },
    queryCurrentWeekInteractTrend: param => {
        //  本周发起教学互动次数趋势
        return http.get(`/orgInteractSituationDay/queryCurrentWeekInteractTrend`, param, 'moni')
    },
    // 监控-教学资源-学院教学资源按日统计情况控制器
    queryOrgResourceDistribution: param => {
        //  各院系教学资源分布/全校
        return http.get(`/orgResourceSituationDay/queryOrgResourceDistribution`, param, 'moni')
    },
    queryCurrentTermInteractTrend: param => {
        // 本学期发起教学互动次数趋势
        return http.get(`/orgInteractSituationDay/queryCurrentTermInteractTrend`, param, 'moni')
    },
    queryOrgResourceTypeNumber: param => {
        // 新增教学资源分布(天,周,学期)
        return http.get(`/orgResourceSituationDay/queryOrgResourceTypeNumber`, param, 'moni')
    },
    queryOrgResourceNumber: param => {
        // 各院系新增教学资源数(天,周,学期)
        return http.get(`/orgResourceSituationDay/queryOrgResourceNumber`, param, 'moni')
    },
    queryOrgResourceDownSeeNumber: param => {
        // 各院系教学资源使用情况-下载,查看量(天,周,学期)
        return http.get(`/orgResourceSituationDay/queryOrgResourceDownSeeNumber`, param, 'moni')
    },
    queryOrgCurrentTermResourceTrend: param => {
        // 学期教学资源新增情况-新增趋势
        return http.get(`/orgResourceSituationDay/queryOrgCurrentTermResourceTrend`, param, 'moni')
    },
    queryTheWeekInteractSchoolJoinStuNumTrend: param => {
        // 本周参与互动人数趋势
        return http.get(`/orgInteractSituationDay/queryTheWeekInteractSchoolJoinStuNumTrend`, param, 'moni')
    },
    queryCurrentTermInteractJoinStuTrend: param => {
        // 本学期参与互动人数趋势
        return http.get(`orgInteractSituationDay/queryCurrentTermInteractJoinStuTrend`, param, 'moni')
    },
    // 实时-教室课堂状态
    liveOrgClassRoomUtilization: param => {
        // 学期教学资源新增情况-新增趋势
        return http.get(`/classRoomState/getSectionBuildingClassRoomUtilization`, param, 'moni')
    },
    treeMemoSystemPrivilegeByUserCode: param => {
        // 用户获取系统权限
        return http.get(`/userPrivilege/treeMemoSystemPrivilegeByUserCode`, param, 'moni')
    },
    situationDayClassSignIn: param => {
        // 点击查看详情
        return http.get(`/situation/day/class/signIn`, param, 'moni')
    },
    situationDaydetail: param => {
        // 班级详情
        return http.get(`/situation/day/class/signIn/detail`, param, 'moni')
    },
    getProjectAndIdentity: param => {
        // 4.5 获取当前用户的评价身份和项目信息
        return http.get(`/classRoomState/getProjectAndIdentity`, param, 'moni')
    },
    getSubTemplateInfo: param => {
        console.log(param)
        // 4.5 根据项目编码获取子模板信息
        return http.get(`/classRoomState/getSubTemplateInfo`, param, 'moni')
    },
    // // 5.1.0 -直播是否外链
    // getcontrolLiveStreamUrl: courseTimetableDetailCode => {
    //     return http.get(`/liveStream/getLiveStreamUrl/${courseTimetableDetailCode}`)
    // },
    // 登录接口
    login: param => {
        return http.post(
            '/defauth/auth',
            Object.assign(
                {
                    platType: 'SELFSYS',
                    passWordEncrypt: 'YES',
                    withIn: 'YES'
                },
                param
            )
        )
    },
    // 退出登录
    outLogin: param => {
        return http.get('/defauth/loginOut', param)
    },
    // 修改密码
    changePassWord: param => {
        return http.post('/defauth/changePassWord', param)
    },
    // 获取身份
    teacherOrStudent: param => {
        return http.get('/menus/identity', param)
    },
    termNear: param => {
        // 若干年学年学期
        return http.get('/term/near', param)
    },
    // 当前学年学期
    term: param => {
        return http.get('/term', param)
    },
    // 通用
    // /term/getCurrentWeekInfo
    currentWeek: param => {
        return http.get('/term/getCurrentWeekInfo', param)
    },
    getDepartmentyearAndtream: param => {
        // 获取学年
        return http.get(`/common/year/info`, param)
    },
    getTchDepName: param => {
        // 获取部门
        return http.get(`/tchWorks/GetTchDepName`, param)
    },
    // 删除记录
    deleteRecord: param => {
        return http.post(`/teachers/eval/delete/${param.userCode}`, param)
    },
    // --------------------------------->
    // 评价-应用模块
    menusList: param => {
        return http.get('/menus/pc', param)
    },
    // 是否有领取任务
    menusDrawTask: param => {
        return http.get(`/task/listTaskIsAccept/${param.userCode}`, param)
    },
    // 评价-当前筛选时间
    // term: (param) => {
    //   return http.get("/term", param);
    // },

    // 评价-当前周-星期
    WeekInfo: param => {
        return http.get('/term/getCurrentWeekInfo', param)
    },
    // 评价-节次
    evalSect: param => {
        return http.get('/eval/common/show/max/section', param)
    },
    // 评价-课程类型
    courseType: param => {
        return http.get('/dictionary/CLASS_CATEGORY_4_ASSESS', param)
    },
    // 评价-开课学院
    courseOrg: param => {
        return http.get(`/teachers/eval/timetable/org/${param.userCode}`, param)
    },
    // 评价-获取校区
    courseCampus: param => {
        return http.get(`/teachers/eval/timetable/campus/${param.userCode}`, param)
    },
    // 评价-获取楼栋
    courseDong: param => {
        return http.get(`/teachers/eval/timetable/tower/${param.userCode}`, param)
    },
    // 评价-获取楼层
    courseFloor: param => {
        return http.get(`/teachers/eval/timetable/layer/${param.userCode}`, param)
    },
    // 评价-获取楼层
    courseClassroom: param => {
        return http.get(`/teachers/eval/timetable/classroom/${param.userCode}`, param)
    },
    // 评价-获取同行 table列表数据
    fieldDatalist: param => {
        return http.get(`/teachers/eval/timetable/list/${param.userCode}`, param)
    },
    /// ////
    // 评价-检测
    gaindetection: param => {
        return http.get(`/evaluateDetection/excellenceRate`, param)
    },
    // 评价-新增、编辑
    gainResult: param => {
        return http.get(`/teachers/eval/get/questionairy/${param.userCode}`, param)
    },
    // 评价-检查是否具备评价条件
    checkoutCondition: param => {
        return http.get(`/teachers/eval/check/haveEvalCondition/${param.userCode}`, param)
    },
    // 评价-提交(编辑、新建)
    establish: (param, param2) => {
        return http.post(`/teachers/eval/add/${param2.userCode}`, param, param2)
    },
    // 4.7.0.0 本学期被评价情况
    evaluatedDetail: param => {
        return http.get(`/teachers/eval/evaluatedDetail/${param.userCode}`, param)
    },
    // 4.7.0.0 提交手写签名
    addEvaluateSignature: (param, param2) => {
        return http.post(`/evaluateSignature/addEvaluateSignature`, param, param2)
    },
    // 领取任务-学年学期
    GetTermNear: param => {
        return http.get(`/term/near`, param)
    },
    // 领取任务-列表
    GetTaskList: param => {
        return http.get(`/task/list/${param.userCode}`, param)
    },
    // 领取任务-获取任务类型列表
    GetTaskType: param => {
        return http.get(`/task/list/tasktype`, param)
    },
    // 领取任务-详情-get提交
    GetTaskDetails: param => {
        return http.get(`/task/${param.taskCode}/${param.localUserCode}`, param)
    },
    // 领取任务-领取-put提交
    GetTaskCommit: param => {
        return http.post(`/task/put/${param.taskCode}/${param.localUserCode}`, param, undefined)
    },
    // 听评课记录-列表
    GetRecordList: param => {
        return http.get(`/teachers/eval/record/list/${param.userCode}`, param)
    },
    // 问卷调查-列表
    GetQuestionnaireList: param => {
        return http.get(`/teachers/${param.userCode}/reviewonline/questionnaires/list`, param)
    },
    // 问卷调查-查看详情
    GetQuestionnaireDetails: param => {
        return http.get(`/teachers/${param.userCode}/reviewonline/questionnaires4End/${param.projectCode}`, param)
    },
    // 问卷调查-是否展示 查看详情
    isShowInfoButton: param => {
        return http.get(`/teachers/${param.userCode}/reviewonline/questionnaires/showInfoButton`, param)
    },
    // 问卷调查-填写问卷
    SetQuestionnaireFill: param => {
        return http.get(`/teachers/${param.userCode}/reviewonline/questionnaires/${param.projectCode}`, param)
    },
    // 问卷调查-提交
    SetQuestionnaireCommit: (param, param2) => {
        return http.post(`/teachers/${param2.operatorId}/reviewonline/questionnaires/${param2.projectCode}`, param, param2)
    },
    // 我的任务-列表
    GetMyTaskList: param => {
        return http.get(`/task/page/detail/${param.localUserCode}`, param)
    },
    // 教师评学-列表
    GetMyTermList: param => {
        return http.get(`/teachers/eval/course/listV3/${param.userCode}`, param)
    },
    // 教师评学-综合评分详情
    GetTermDetails: param => {
        return http.get(`/teachers/eval/course/timetbale/show/${param.userCode}`, param)
    },
    // 教师评学-是否展示评价次数
    MackTermFrequency: param => {
        return http.get(`/eval/common/show/evaluate/times`, param)
    },
    // 教师评学-次数模式列表
    GetTermFreList: param => {
        return http.get(`/teachers/eval/course/times/list/${param.userCode}`, param)
    },
    // 教师评学-课表模式列表
    GetTermCourseList: param => {
        return http.get(`/teachers/eval/course/timetbale/list/${param.userCode}`, param)
    },
    // 教师评学-查看节次评价明细
    GetTermCourseEvaluation: param => {
        return http.get(`/studentevaluate/evalinfo`, param)
    },
    // 教师评学-修改、编辑
    SetgainResult: param => {
        return http.get(`/teachers/eval/course/questionnairy/${param.userCode}`, param)
    },
    // 评价-提交
    Setestablish: (param, param2) => {
        return http.post(`/teachers/eval/course/questionnaire/${param2.userCode}`, param, param2)
    },
    // 教学工作量列表
    typeWorkload_A: param => {
        return http.get(`/tchWorks/QueryTchWorks`, param)
    },
    // 非教学工作量列表
    typeWorkload_B: param => {
        return http.get(`/tchWorks/QueryTchWorksClassB`, param)
    },
    // 教师加分项列表
    typeWorkload_C: param => {
        return http.get(`/teacherAddScoreRecord/teacherAddScoreRecord`, param)
    },
    // 上传文件
    typeWorkload_Add_C: (param, param1) => {
        return http.post(`/teacherAddScoreRecord/updateFilePath/${param}`, param1)
    },
    // 保存教师加分项
    typeWorkload_Save_C: (param, param1) => {
        return http.post(`/teacherAddScoreRecord/updateTeacherAddScore/${param}`, param1)
    },
    // 新增教学工作量
    typeWorkload_Add_A: (param, param2) => {
        return http.post(`/tchWorks/InsertTchWorksDetails`, param, param2)
    },
    // 编辑教学工作量
    typeWorkload_update_A: (param, param2) => {
        return http.post(`/tchWorks/UpdateTchWorksDetails`, param, param2)
    },
    // 新增非教学工作量
    typeWorkload_Add_B: (param, param2) => {
        return http.post(`/tchWorks/InsertTchWorksClassB`, param, param2)
    },
    //  教学工作量详情
    typeWorkload_details_A: param => {
        return http.get(`/tchWorks/QueryTchWorksDetails`, param)
    },
    //  非教学工作量详情
    typeWorkload_details_B: (param, param2) => {
        return http.get(`/tchWorks/QueryTchWorksClassB`, param)
    },
    //  重点关注教师
    focusOn_tch_info: (param, param2) => {
        return http.get(`/focusOn/tch/info`, param)
    },
    //  重点关注课程
    focusOn_course_info: (param, param2) => {
        return http.get(`/focusOn/course/info`, param)
    },
    // 未被评价教师名单
    focusOn_notEval: (param, param2) => {
        return http.get(`/focusOn/notEval`, param)
    },
    // 4.3.0 列表查询 - 移动端管理员、PC端应用
    onlineFeedback_list: (param, param2) => {
        return http.get(`/onlineFeedback/list`, param)
    },
    selOnlineFeedbackDetail: (param, param2) => {
        return http.get(`/onlineFeedback/selOnlineFeedbackDetail/${param.onlineFeedbackCode}`, param)
    },
    // 评价-提交
    onlineFeedbackSub: (param, param2) => {
        return http.post(`/onlineFeedback/update/${param.userCode}`, param, param2)
    },
    // nav
    dictionaryTIMETABLE_SOURCE: param => {
        // 用户获取系统权限
        return http.get(`/dictionary/TIMETABLE_SOURCE`, param)
    },
    // 4.4.0 - 查询项目子模板
    commonProjectTemplateSub: param => {
        return http.get(`/common/project/templateSub`, param)
    },
    // 5.1.0 - 巡考任务列表
    patrolTaskGroupList: param => {
        return http.get(`/patrolExamTask/taskGroupList`, param)
    },
    // 5.1.0 - 巡考任务-巡考督导人员列表
    patrolTaskMemberList: param => {
        return http.get(`/patrolExamTask/patrolTaskMemberList`, param)
    },
    // 5.1.0 - 巡考任务-巡考地点列表
    campusBuildingByTaskGroup: param => {
        return http.get(`/patrolExamTask/campusBuildingByTaskGroup`, param)
    },
    // 5.1.0 - 巡考任务-巡考时间列表
    weekSchedulingList: (taskGroupCode, param) => {
        return http.get(`/patrolExamTask/weekSchedulingList/${taskGroupCode}`, param)
    },
    // 5.1.0 -巡考任务- 提交分配任务
    postallocationTask: (taskGroupCode, param) => {
        return http.post(`/patrolExamTask/allocationTask/${taskGroupCode}`, param)
    },
    // 5.1.0 -巡考任务- 督导任务列表
    gettaskList: param => {
        return http.get(`/patrolExamTask/taskList`, param)
    },
    // 5.1.0 -巡考任务- 督导任务列表-编辑时-获取任务详情
    getTaskByCode: (taskCode, param) => {
        return http.get(`/patrolExamTask/getTaskByCode/${taskCode}`, param)
    },
    // 5.1.0 -巡考任务- 督导任务列表-删除
    postdeleteTask: (taskCode, param) => {
        return http.post(`/patrolExamTask/deleteTask/${taskCode}`, param)
    },
    // 5.1.0 -巡考任务- 督导任务列表-修改
    postupdateTask: (taskCode, param) => {
        return http.post(`/patrolExamTask/updateTask/${taskCode}`, param)
    },
    // 5.1.0 -巡考记录-数据列表
    patrolExamRecordList: (taskCode, param) => {
        return http.get(`/patrolExamTask/patrolExamRecordList/${taskCode}`, param)
    },
    // 5.1.0 -按任务获取楼栋列表
    buildingListByTaskCode: (taskCode, param) => {
        return http.get(`/patrolExamTask/buildingListByTaskCode/${taskCode}`, param)
    },
    // 5.1.0 -按任务获取巡考的楼栋记录
    getPatrolExamBuildingRecord: (taskCode, buildingCode, param) => {
        return http.get(`/patrolExamTask/getPatrolExamBuildingRecord/${taskCode}/${buildingCode}`, param)
    },
    // 5.1.0 巡考任务-按学年学期获取关联的考场数
    gettaskExamRoomCount: (taskGroupCode, param) => {
        return http.get(`/patrolExamTask/taskExamRoomCount/${taskGroupCode}`, param)
    },
    // 5.1.0 教学秩序巡查- 巡查任务列表
    coursepatrolTaskGroupList: param => {
        return http.get(`/patrolCourseTask/taskGroupList`, param)
    },
    // 5.1.0 - 教学秩序巡查-巡查督导人员列表
    coursepatrolTaskMemberList: param => {
        return http.get(`/patrolCourseTask/patrolTaskMemberList`, param)
    },
    // 5.1.0 - 教学秩序巡查-巡查地点列表
    coursecampusBuildingByTaskGroup: param => {
        return http.get(`/patrolCourseTask/campusBuildingByTaskGroup`, param)
    },
    // 5.1.0 - 教学秩序巡查-巡查时间列表
    courseweekSchedulingList: (taskGroupCode, param) => {
        return http.get(`/patrolCourseTask/weekSchedulingList/${taskGroupCode}`, param)
    },
    // 5.1.0 -教学秩序巡查- 提交分配任务
    coursepostallocationTask: (taskGroupCode, param) => {
        return http.post(`/patrolCourseTask/allocationTask/${taskGroupCode}`, param)
    },
    // 5.1.0 -教学秩序巡查- 督导任务列表
    coursegettaskList: param => {
        return http.get(`/patrolCourseTask/taskList`, param)
    },
    // 5.1.0 -教学秩序巡查- 督导任务列表-编辑时-获取任务详情
    coursegetTaskByCode: (taskCode, param) => {
        return http.get(`/patrolCourseTask/getTaskByCode/${taskCode}`, param)
    },
    // 5.1.0 -教学秩序巡查- 督导任务列表-删除
    coursepostdeleteTask: (taskCode, param) => {
        return http.post(`/patrolCourseTask/deleteTask/${taskCode}`, param)
    },
    // 5.1.0 -教学秩序巡查- 督导任务列表-修改
    coursepostupdateTask: (taskCode, param) => {
        return http.post(`/patrolCourseTask/updateTask/${taskCode}`, param)
    },
    // 5.1.0 教学秩序巡查-巡查记录-数据列表
    coursepatrolExamRecordList: (taskCode, param) => {
        return http.get(`/patrolCourseTask/patrolRecordList/${taskCode}`, param)
    },
    // 5.1.0 教学秩序巡查-按任务获取楼栋列表
    coursebuildingListByTaskCode: (taskCode, param) => {
        return http.get(`/patrolCourseTask/buildingListByTaskCode/${taskCode}`, param)
    },
    // 5.1.0 教学秩序巡查-按任务获取巡查的楼栋记录
    coursegetPatrolExamBuildingRecord: (taskCode, buildingCode, param) => {
        return http.get(`/patrolCourseTask/getPatrolBuildingRecord/${taskCode}/${buildingCode}`, param)
    },
    // 5.1.0 -直播是否外链
    getLiveStreamUrl: courseTimetableDetailCode => {
        return http.get(`/liveStream/getLiveStreamUrl/${courseTimetableDetailCode}`)
    },
    // 5.1.0 专项督导听课任务-分配听课任务
    specialSuperAttendallocationTask: (taskGroupCode, param) => {
        return http.post(`/specialSuperAttendALectureTask/allocationTask/${taskGroupCode}`, param)
    },
    // 5.1.0专项督导听课任务-听课记录/评价记录
    specialSuperAttendRecordList: param => {
        return http.get(`/specialSuperAttendALectureTask/attendALectureRecordList`, param)
    },
    // 5.1.0专项督导听课任务-听课安排列表
    specialSuperAttendSchedulingList: param => {
        return http.get(`/specialSuperAttendALectureTask/attendALectureSchedulingList`, param)
    },
    // 5.1.0专项督导听课任务-听课课程安排列表
    specialSuperAttendcourseSchedulingList: param => {
        return http.get(`/specialSuperAttendALectureTask/courseSchedulingList`, param)
    },
    // 5.1.0 专项督导听课任务-删除任务
    useSpecialSuperAttenddeleteTask: (taskCode, param) => {
        return http.post(`/specialSuperAttendALectureTask/deleteTask/${taskCode}`, param)
    },
    // 5.1.0专项督导听课任务-获取任务
    specialSuperAttendgetTaskByCode: (taskCode, param) => {
        return http.get(`/specialSuperAttendALectureTask/getTaskByCode/${taskCode}`, param)
    },
    // 5.1.0专项督导听课任务-获取任务督导人员列表
    specialSuperAttendpatrolTaskMemberList: param => {
        return http.get(`/specialSuperAttendALectureTask/patrolTaskMemberList`, param)
    },
    // 5.1.0 专项督导听课任务-评教记录-新增
    specialSuperAttendSubmitTask: (param, param2) => {
        return http.post(`/specialSuperAttendALectureTask/submitEvaluate/${param2.taskCode}`, param, param2)
    },
    // 5.1.0专项督导听课任务-任务组列表
    specialSuperAttendtaskGroupList: param => {
        return http.get(`/specialSuperAttendALectureTask/taskGroupList`, param)
    },
    // 5.1.0专项督导听课任务-分配巡课任务-列表
    specialSuperAttendtaskList: param => {
        return http.get(`/specialSuperAttendALectureTask/taskList`, param)
    },
    // 5.1.0 专项督导听课任务-更新任务
    specialSuperAttendupdateTaskTask: (taskCode, param2) => {
        return http.post(`/specialSuperAttendALectureTask/updateTask/${taskCode}`, param2)
    },
    // 5.1.0专项督导听课任务-用户任务列表
    specialSuperAttenduserTaskList: param => {
        return http.get(`/specialSuperAttendALectureTask/userTaskList`, param)
    }, // 5.1.0专项督导听课任务-获取任务组的周次星期安排
    specialSuperAttendweekSchedulingList: (taskGroupCode, param) => {
        return http.get(`/specialSuperAttendALectureTask/weekSchedulingList/${taskGroupCode}`, param)
    },
    // 获取分析菜单-5.2.0
    GET_TREEPOINTSYSTEMPRIVILEGE: param => {
        return http.get('/userPrivilege/treePointSystemPrivilege', param, 'moni')
    },
    // 获取年级-5.2.0从分析迁入
    getGrade: param => {
        return http.get('/common/grade/info', param, 'count')
    },
    // 获取学年学期-5.2.0从分析迁入
    getTremInfo: param => {
        return http.get('/common/term/info', param, 'count')
    },
    // 获取时间-周次
    getTermWeek: param => {
        return http.get('/common/term/week', param, 'count')
    },
    //4.3.0 获取当前周
    getCurrentWeekInfo: param => {
        return http.get('/common/week/info', param, 'count')
    },
    // 得分分布-获取统计维度
    getTjwd: param => {
        return http.get('/common/tch/eval/statistic/list', param, 'count')
    },
    // 获取院系
    getCollege: param => {
        return http.get('/common/orgsNew', param, 'count')
    },
    // 获取当前角色的学院
    postThisColleg: (data, params) => {
        return http.post('/analysePointRole/postPointRoleByUser', data, params, 'point')
    },
    // 院系考勤数据
    getsSttendOrg: param => {
        return http.get('/attend/org', param, 'count')
    },
    //4.6.0 班级考勤旷课
    studentAbsentStatistics: param => {
        return http.get('/attend/studentAbsentStatistics', param, 'count')
    },
    //得分分布  获取 同行评教得分分布 评教项目
    getSDpeerproject: param => {
        return http.get('/tch/eval/score/colleague/project', param, 'count')
    },
    // 得分分布 获取 学生评教得分分布 评教项目
    getSDstuproject: param => {
        return http.get('/tch/eval/score/student/project', param, 'count')
    },
    // 得分分布 获取 督导评教得分分布 评教项目
    getSDsupproject: param => {
        return http.get('/tch/eval/score/supervisor/project', param, 'count')
    },
    // 得分分布 获取 领导评教得分分布 评教项目
    getSDleadproject: param => {
        return http.get('/tch/eval/score/leader/project', param, 'count')
    },
    // 获取（参评率）评教属性
    getjoinPreEvalType: param => {
        return http.get('/common/frequencyType/info', param, 'count')
    },
    // 获取客观指标
    getkpiLevel: param => {
        return http.get('/common/objectiveKpis', param, 'count')
    },
    // 获取评价项目
    getParm: param => {
        return http.get('/common/evaluateProject/parm', param, 'count')
    },
    //4.3.0 班级考勤异常数据
    attendAbnormal: param => {
        return http.get('/attend/abnormal', param, 'count')
    },
    // 班级考勤数据
    getsSttendClass: param => {
        return http.get('/attend/class', param, 'count')
    },
    // 学生考勤数据
    getsSttendStu: param => {
        return http.get('/attend/stu', param, 'count')
    },
    // 学生考勤预警列表
    getsWarningStu: param => {
        return http.get('/early/warning/stu', param, 'count')
    },
    // 班级考勤预警列表
    getsWarningClass: param => {
        return http.get('/early/warning/class', param, 'count')
    },
    // 行政班 统计 导出完全未评学生名单
    getClassExportNoEval: param => {
        return http.get('/stu/eval/join/class/export/noeval', param, 'count')
    },
    //  行政班 统计 导出部分未评学生名单
    getClassExportEvaled: param => {
        return http.get('/stu/eval/join/class/export/evaled', param, 'count')
    },
    // 教学班 导出教学班完全未评学生名单
    getNoEvalStudentsByTeachingClass: param => {
        return http.get('/stu/eval/join/noEvalStudentsByTeachingClass', param, 'count')
    },
    // 后端未找到接口
    getLearnExportEvaled: param => {
        return http.get('/stu/eval/join/learn/export/evaled', param, 'count')
    },
    // 查询 全校参评率
    getParticipatSchool: param => {
        return http.get('/stu/eval/join/all/org/info', param, 'count')
    },
    // 查询 教学班参评率
    getParticipatLearn: param => {
        return http.get('/stu/eval/join/teachingClass/info', param, 'count')
    },
    //各个按钮是否显示、隐藏（权重、等级...）
    whetherJudge: (param, data) => {
        return http.post('/pointFunction/getPointFunctionByUserCode', param, data, 'point')
    },
    //教师单个指标得分对比
    getLeaderTeacherKpi: param => {
        return http.get('/leaderEvaluationTeaching/teacherKpi', param, 'count')
    },
    //教师单个指标得分对比
    getSupervisorTeacherKpi: param => {
        return http.get('/supervisorEvaluationTeaching/teacherKpi', param, 'count')
    },
    //教师单个指标得分对比
    getStudentTeacherKpi: param => {
        return http.get('/studentEvaluationTeaching/teacherKpi', param, 'count')
    },
    // 查询 专业参评率
    getParticipatMajor: param => {
        return http.get('/stu/eval/join/major/info', param, 'count')
    },
    // 查询 课程参评率
    getParticipatCourse: param => {
        return http.get('/stu/eval/join/course/info', param, 'count')
    },
    // 查询 行政班参评率
    getParticipatPoltics: param => {
        return http.get('/stu/eval/join/class/info', param, 'count')
    },
    // 获取专业
    getMajor: param => {
        return http.get('/common/major/info', param, 'count')
    },
    //获取评教身份列表(督导角色，领导角色)
    getIdentityType: param => {
        return http.get('/common/identity/type', param, 'count')
    },
    //获取教师类型
    getStaffTypes: param => {
        return http.get('/common/staffTypes', param, 'count')
    },
    //获取课程类型
    getCourses: param => {
        return http.get('/common/courses', param, 'count')
    },
    //教师单个指标得分对比
    getColleagueTeacherKpi: param => {
        return http.get('/colleagueEvaluationTeaching/teacherKpi', param, 'count')
    },
    // 获取课程类型
    getCourseType: param => {
        return http.get('/common/courseType/list', param, 'count')
    },
    //各课程对比分析
    getSupervisorCourse: param => {
        return http.get('/supervisorEvaluationTeaching/course', param, 'count')
    },
    //各课程对比分析
    getLeaderCourse: param => {
        return http.get('/leaderEvaluationTeaching/course', param, 'count')
    },
    //各课程对比分析
    getColleagueCourse: param => {
        return http.get('/colleagueEvaluationTeaching/course', param, 'count')
    },
    //各课程对比分析
    getStudentCourse: param => {
        return http.get('/studentEvaluationTeaching/course', param, 'count')
    },
    //各教师得分对比分析y
    getSupervisorTeacher: param => {
        return http.get('/supervisorEvaluationTeaching/teacher', param, 'count')
    },
    //各教师得分对比分析
    getLeaderTeacher: param => {
        return http.get('/leaderEvaluationTeaching/teacher', param, 'count')
    },
    //各教师得分对比分析
    getColleagueTeacher: param => {
        return http.get('/colleagueEvaluationTeaching/teacher', param, 'count')
    },
    //各课程教师得分对比分析
    getStudentCourseTeacher: param => {
        return http.get('/studentEvaluationTeaching/courseTeacher', param, 'count')
    },
    //各教师对比分析
    getStudentAllTeacher: param => {
        return http.get('/studentEvaluationTeaching/allTeacher', param, 'count')
    },
    //4.2.2 学生评教得分查询 - 可以设置教师成
    getStudentAllTeacherInspect: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/inspect', param, 'count')
    },
    //教师得分导出
    getStudentAllTeacherExport: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/export', param, 'count')
    },
    //教师得分详情信息
    getStudentAllTeacherDetail: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/detail', param, 'count')
    },
    // 查询权重
    getWeight: param => {
        return http.get('/eval/collect/weight/info', param, 'count')
    },
    // 查询单个权重信息
    getweightScoreSetSingle: param => {
        return http.get('/tch/quality/score/year/weight/single/info', param, 'count')
    },
    // 查询单个权重信息
    getspecialSupervisorEvalSetSingle: param => {
        return http.get('/eval/specialSupervisorEval/weight/single/info', param, 'count')
    },
    //4.2.2 查询个人权重信息
    weightSingleInfo: param => {
        return http.get('/eval/collect/weight/single/info', param, 'count')
    },
    // 根据学期范围查询评教项目
    getTermRangeProject: param => {
        return http.get('/common/evaluateProject/termRange', param, 'count')
    },
    //4.2.2 设置个人权重信息
    setSingle: (param, data) => {
        return http.post('/eval/collect/weight/single/set', param, data, 'count')
    },
    // 设置单个权重信息
    weightScoreSetSingle: (param, data) => {
        return http.post('/tch/quality/score/year/weight/single/set', param, data, 'count')
    },
    // 设置单个权重信息
    specialSupervisorEvalSetSingle: (param, data) => {
        return http.post('/eval/specialSupervisorEval/weight/single/set', param, data, 'count')
    },
    //4.3.0 设置批量权重信息
    weightBatchSet: (param, data) => {
        return http.post('/eval/collect/weight/batch/set', param, data, 'count')
    },
    // 设置批量权重信息
    weightScoreSetAll: (param, data) => {
        return http.post('/tch/quality/score/year/weight/batch/set', param, data, 'count')
    },
    // 设置批量权重信息
    specialSupervisorEvalSetAll: (param, data) => {
        return http.post('/eval/specialSupervisorEval/weight/batch/set', param, data, 'count')
    },
    //4.4.0学生评教指标总览
    stuEvalExtendKpiSelectInfo: param => {
        return http.get('/stuEvalExtend/kpiSelectInfo', param, 'count')
    },
    //4.3.0 - 主观评价
    outsideEvalSumGetSubjectives: param => {
        return http.get('/outsideEvalSum/getSubjectives', param, 'count')
    },
    //4.3.0 - 外部客观评价
    outsideEvalSumGetObjectivities: param => {
        return http.get('/outsideEvalSum/getObjectivities', param, 'count')
    },
    //4.4.0学生评教分析-按教师
    studentEvaLabelTeacher: param => {
        return http.get('/evalLabel/tchInfo', param, 'count')
    },
    //4.4.0学生评教分析-按课程
    studentEvaLabelCourse: param => {
        return http.get('/evalLabel/courseInfo', param, 'count')
    },
    //4.7.3 学生评教教师得分
    studentReporterEvaluationTeacher: param => {
        return http.get('/studentReporterEvaluationTeacher/allTeacher', param, 'count')
    },
    //4.7.3 学生评教课程得分
    studentReporterEvaluationallCourse: param => {
        return http.get('/studentReporterEvaluationTeacher/allCourse', param, 'count')
    },
    //4.2.2 学生评教教师得分-得分报告
    allTeacherReport: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/report', param, 'count')
    },
    // 部门各个指标
    getOrgKpi: param => {
        return http.get('/stu/eval/compare/org/kpi', param, 'count')
    },
    // 教师各个指标
    getTchkpi: param => {
        return http.get('/stu/eval/compare/tch/kpi', param, 'count')
    },
    // 教师所任课程指标
    getTch4course: param => {
        return http.get('/stu/eval/compare/tch4course', param, 'count')
    },
    // 课程教学质量预警
    getWarningCourse: param => {
        return http.get('/early/warning/course', param, 'count')
    },
    // 教师教学质量预警
    getWarningTch: param => {
        return http.get('/early/warning/tch', param, 'count')
    },
    //4.5.0 - 学生评教得分汇总
    studentEvaluationTeachingCollectInfo: param => {
        return http.get('/studentEvaluationTeaching/collectInfo', param, 'count')
    },
    // 课程各个指标
    getCourseKpi: param => {
        return http.get('/stu/eval/compare/course/kpi', param, 'count')
    },
    // 课程各教师指标得分对比
    getCourse4tch: param => {
        return http.get('/stu/eval/compare/course4tch', param, 'count')
    },
    // 获取部门
    getDepart: param => {
        return http.get('/common/org/info', param, 'count')
    },
    // 问卷调查（参评）
    getOrgQuesPercentList: param => {
        return http.get('/sQuesPercent/getOrgQuesPercentList', param, 'count')
    },
    // 获取问卷发起部门
    getQuedepart: param => {
        return http.get('/common/orgsNew', param, 'count')
    },
    //4.3.0 - 实习企业
    outsideEvalSumGetEnterprise: param => {
        return http.get('/outsideEvalSum/getEnterprise', param, 'count')
    },
    // 获取问卷指标
    getQuesPercent: param => {
        return http.get('/sQuesPercent/quesPercent', param, 'count')
    },
    // 问卷明细导出
    getQuestUserFilledInfoExport: param => {
        return http.get('/sQuesPercent/questUserFilledInfoExport', param, 'count')
    },
    // 问卷调查-导出
    getQuesExport: param => {
        return http.get('/sQuesPercent/quesExport', param, 'count')
    },
    // 查询问卷问答题
    getQuesAnswersrList: param => {
        return http.get('/sQuesPercent/quesAnswersrList', param, 'count')
    },
    // 获取图片列表
    getQuesImagePathList: param => {
        return http.get('/sQuesPercent/quesImagePathList', param, 'count')
    },
    //设置项目KPI指标权限参与计算
    setEvaluateProjectKpiOptionInclCalcuate: (param, data) => {
        return http.post('/sQuesPercent/setEvaluateProjectKpiOptionInclCalcuate', param, data, 'count')
    },
    getSetEvaluateProjectKpiOptionInclCalcuate: param => {
        return http.get('/sQuesPercent/getSetEvaluateProjectKpiOptionInclCalcuate', param, 'count')
    },
    //获取项目KPI
    getEvaluateProjectKpi: param => {
        return http.get('/sQuesPercent/getEvaluateProjectKpi', param, 'count')
    },
    getNotPartakeGraduateSurvey: param => {
        return http.get('/sQuesPercent/notPartakeGraduateSurvey', param, 'count')
    },
    getQuesSurveyGraduateKpiStaisfactionRanking: param => {
        return http.get('/sQuesPercent/quesSurveyGraduateKpiStaisfactionRanking', param, 'count')
    },
    getQuesKpiSurveyGraduateKpiOrgSatisfaction: param => {
        return http.get('/sQuesPercent/quesKpiSurveyGraduateKpiOrgSatisfaction', param, 'count')
    },
    getQuesMajorSurveyGraduateKpiSatisfaction: param => {
        return http.get('/sQuesPercent/quesMajorSurveyGraduateKpiSatisfaction', param, 'count')
    },
    getQuesPercentDetail: param => {
        return http.get('/sQuesPercent/getQuesPercentDetail', param, 'count')
    },
    postTeachingResourcesList: (data, param) => {
        return http.post('/sTchResourceNum/teachingResourcesList', data, param, 'count')
    },
    postTeachingResourceUseList: (data, param) => {
        return http.post('/sTchResourceUseNum/teachingResourceUseList', data, param, 'count')
    },
    // 课堂互动分析
    postInteractJoinList: (data, param) => {
        return http.post('/sInteractJoin/interactJoinList', data, param, 'count')
    },
    //4.3.0 外部评价项目列表
    outsideEvalSumProjectInfo: param => {
        return http.get('/outsideEvalSum/projectInfo', param, 'count')
    },
    //4.3.0 教师评价得分异常分析 - 详情
    evalAbnormalTchDetail: param => {
        return http.get('/evalAbnormal/tch/detail', param, 'count')
    },
    //4.3.0 课程评价得分异常分析 - 详情
    evalAbnormalCourseDetail: param => {
        return http.get('/evalAbnormal/course/detail', param, 'count')
    },
    //4.3.0 教师评价得分异常分析 - 列表
    evalAbnormalTchList: param => {
        return http.get('/evalAbnormal/tch/list', param, 'count')
    },
    //4.3.0 课程评价得分异常分析 - 列表
    evalAbnormalCourseList: param => {
        return http.get('/evalAbnormal/course/list', param, 'count')
    },
    //4.3.0 设置异常标准设置
    evalAbnormalSetConfig: (data, param) => {
        return http.post('/evalAbnormal/setConfig', data, param, 'count')
    },
    //4.3.0 设置异常标准设置
    evalAbnormalGetConfig: param => {
        return http.get('/evalAbnormal/getConfig', param, 'count')
    },
    //获取分析点标签列表
    listAnalyseLable: (data, param) => {
        return http.post('/analyseLable/listAnalyseLable', data, param, 'count')
    },
    //我的常用分析点
    getMostPoitList: (data, param) => {
        return http.post('/analysePoint/getMostPoitList', data, param, 'point')
    },
    //插入访问日
    pointLogAdd: (data, param) => {
        return http.post('/pointLog/add', data, param, 'point')
    },
    //分析点搜索
    analysePointSearch: (data, param) => {
        return http.post('/analysePoint/analysePointSearch', data, param, 'count')
    },
    //4.4.0 -项目列表
    reportCourseOrgProjectList: param => {
        return http.get('/reportCourseOrg/projectList', param, 'count')
    },
    //4.4.0 -项目内评价信息
    reportCourseOrgEvalInfo: param => {
        return http.get('/reportCourseOrg/evalInfo', param, 'count')
    },
    //4.4.0 -开课部门指标雷达图
    reportCourseOrgKpiChart: param => {
        return http.get('/reportCourseOrg/kpiChart', param, 'count')
    },
    //4.4.0 -各课程指标评分分析
    reportCourseOrgKpiScore: param => {
        return http.get('/reportCourseOrg/kpiScore', param, 'count')
    },
    //4.4.0 -课程排名
    reportCourseOrgKpiOrder: param => {
        return http.get('/reportCourseOrg/kpiOrder', param, 'count')
    },
    //4.4.0 -开课部门课程得分分布
    reportCourseOrgScoreInfo: param => {
        return http.get('/reportCourseOrg/scoreInfo', param, 'count')
    },
    //4.4.0 -开课部门课程学生评价得分趋势
    repScoreTermDetail: param => {
        return http.get('/reportCourseOrg/scoreTermDetail', param, 'count')
    },
    //全校评价总体情况
    reportSchoolAllEval: param => {
        return http.get('/reportSchool/allEval', param, 'count')
    },
    //教师信息
    teacherSchoolTchInfo: param => {
        return http.get('/teacherSchool/tchInfo', param, 'count')
    },
    //全校教学检测简报 - 是否存在听评课模块
    courseHearEvaluateShow: param => {
        return http.get('/schoolTeachingInspectionBriefing/courseHearEvaluateShow', param, 'count')
    },
    //全校教学检测简报 - 报告明细（4.7.1）
    reportInfo: param => {
        return http.get('/schoolTeachingInspectionBriefing/reportInfo', param, 'count')
    },
    //学院评价总体情况、学院教师学生得分趋势
    reportOrgEval: param => {
        return http.get('/reportOrg/orgEval', param, 'count')
    },
    //学生评价分析 - 项目列表
    reportOrgProjectList: param => {
        return http.get('/reportOrg/projectList', param, 'count')
    },
    //学生评价分析 - 介绍、评分细则、指标雷达图
    reportOrgIntroduce: param => {
        return http.get('/reportOrg/introduce', param, 'count')
    },
    //学生评价分析 - 各专业指标评分分析
    reportOrgKpiScore: param => {
        return http.get('/reportOrg/kpiScore', param, 'count')
    },
    //学生评价分析 - 各年级各专业评价结果
    reportOrgGradeEval: param => {
        return http.get('/reportOrg/gradeEval', param, 'count')
    },
    //学生评价分析 - 得分较高、较低的课程
    reportOrgCourseScore: param => {
        return http.get('/reportOrg/courseScore', param, 'count')
    },
    //学生评价分析 - 得分较高、较低的教师
    reportOrgTchScore: param => {
        return http.get('/reportOrg/tchScore', param, 'count')
    },
    //学生评价分析 - 教师综合得分
    reportOrgTchAllInfo: param => {
        return http.get('/reportOrg/tchAllInfo', param, 'count')
    },
    //评价量表
    reportSchoolKpiInfo: param => {
        return http.get('/reportSchool/kpiInfo', param, 'count')
    },
    //得分较高的课程
    reportSchoolHighScore: param => {
        return http.get('/reportSchool/highScore', param, 'count')
    },
    //得分较高的教师
    reportSchoolHighScoreTch: param => {
        return http.get('/reportSchool/highScoreTch', param, 'count')
    },
    //学生参评率
    reportSchoolStuEvalPer: param => {
        return http.get('/reportSchool/stuEvalPer', param, 'count')
    },
    //评价覆盖率
    reportSchoolTchEvalPer: param => {
        return http.get('/reportSchool/tchEvalPer', param, 'count')
    },
    //评分对比
    reportSchoolScoreCompare: param => {
        return http.get('/reportSchool/scoreCompare', param, 'count')
    },
    //指标分析
    reportSchoolKpiAnalysis: param => {
        return http.get('/reportSchool/kpiAnalysis', param, 'count')
    },
    //指标分析
    reportSchoolKpiAnalysis: param => {
        return http.get('/reportSchool/kpiAnalysis', param, 'count')
    },
    //学生评价 - 获取教师课程列表
    teacherSchoolCourseList: param => {
        return http.get('/teacherSchool/courseList', param, 'count')
    },
    //项目列表
    teacherSchoolProjectList: param => {
        return http.get('/teacherSchool/projectList', param, 'count')
    },
    //学生评价 - 各主观指标得分详情
    teacherSchoolTchKpiContent: param => {
        return http.get('/teacherSchool/tchKpiContent', param, 'count')
    },
    //学生评价 - 各客观指标得分详情
    teacherSchoolTchKpiDetail: param => {
        return http.get('/teacherSchool/tchKpiDetail', param, 'count')
    },
    //课程分析 -- 各指标得分详情
    teacherSchoolCourseKpiDetail: param => {
        return http.get('/teacherSchool/courseKpiDetail', param, 'count')
    },
    //课程分析 -- 各指标得分分析
    teacherSchoolCourseKpiScore: param => {
        return http.get('/teacherSchool/courseKpiScore', param, 'count')
    },
    //学生评价 - 各指标得分分析
    teacherSchoolTchKpiScore: param => {
        return http.get('/teacherSchool/tchKpiScore', param, 'count')
    },
    //课程得分趋势分析
    teacherSchoolCourseScoreTrend: param => {
        return http.get('/teacherSchool/courseScoreTrend', param, 'count')
    },
    //教师得分趋势
    teacherSchoolTchScoreTrend: param => {
        return http.get('/teacherSchool/tchScoreTrend', param, 'count')
    },
    // 查询 学生多学期纵向对比分析
    getStuVertical: param => {
        return http.get('/studentEvaluationTeaching/historyContrast', param, 'count')
    },
    // 查询 督导多学期纵向对比分析
    getSuperorVertical: param => {
        return http.get('/supervisorEvaluationTeaching/historyContrast', param, 'count')
    },
    // 查询 领导多学期纵向对比分析
    getLeaderVertical: param => {
        return http.get('/leaderEvaluationTeaching/historyContrast', param, 'count')
    },
    // 查询 同行多学期纵向对比分析
    getPeerVertical: param => {
        return http.get('/colleagueEvaluationTeaching/historyContrast', param, 'count')
    },
    postQualityScoreImportInfo: (data, param) => {
        return http.post('/tch/quality/score/import/info', data, param, 'count')
    },
    postQualityScoreYearImportInfo: (data, param) => {
        return http.post('/tch/quality/score/year/import/info', data, param, 'count')
    },
    // 导出评教综合对比分析
    getCA: param => {
        return http.get('/CA', param, 'count')
    },
    // 学生评教得分-部门
    getTchEvalScoreStudentOrgInfo: param => {
        return http.get('/tch/eval/score/student/org/info', param, 'count')
    },
    // 学生评教得分-课程类型
    getTchEvalScoreStudentCourseTypeInfo: param => {
        return http.get('/tch/eval/score/student/course_type/info', param, 'count')
    },
    // 学生评教得分-教师类型
    getTchEvalScoreStudentTchTypeInfo: param => {
        return http.get('/tch/eval/score/student/tch_type/info', param, 'count')
    },
    // 督导评教得分分布-部门
    getTchEvalScoreSupervisorOrgInfo: param => {
        return http.get('/tch/eval/score/supervisor/org/info', param, 'count')
    },
    // 督导评教得分分布-课程类型
    getTchEvalScoreSupervisorCourseTypeInfo: param => {
        return http.get('/tch/eval/score/supervisor/course_type/info', param, 'count')
    },
    // 督导评教得分分布-教师类型
    getTchEvalScoreSupervisorTchTypeInfo: param => {
        return http.get('/tch/eval/score/supervisor/tch_type/info', param, 'count')
    },
    // 领导评教得分-部门
    getTchEvalScoreLeaderOrgInfo: param => {
        return http.get('/tch/eval/score/leader/org/info', param, 'count')
    },
    // 领导评教得分-课程类型
    getTchEvalScoreLeaderCourseTypeInfo: param => {
        return http.get('/tch/eval/score/leader/course_type/info', param, 'count')
    },
    // 领导评教得分-教师类型
    getTchEvalScoreLeaderTchTypeInfo: param => {
        return http.get('/tch/eval/score/leader/tch_type/info', param, 'count')
    },
    // 同行评教得分分布-部门
    getTchEvalScoreColleagueOrgInfo: param => {
        return http.get('/tch/eval/score/colleague/org/info', param, 'count')
    },
    // 同行评教得分分布-课程类型
    getTchEvalScoreColleagueCourseTypeInfo: param => {
        return http.get('/tch/eval/score/colleague/course_type/info', param, 'count')
    },
    // 同行评教得分分布-教师类型
    getTchEvalScoreColleagueTchTypeInfo: param => {
        return http.get('/tch/eval/score/colleague/tch_type/info', param, 'count')
    },
    //4.2.2 获取所有教师的权重信息
    getWeightInfo: param => {
        return http.get('/tch/quality/score/all/info/get/weight', param, 'count')
    },
    //获取所有老师的权重信息
    qualityscoreyearinfoallweight: param => {
        return http.get('/tch/quality/score/year/all/info/get/weight', param, 'count')
    },
    //获取所有老师的权重信息
    specialSupervisorEvalallweight: param => {
        return http.get('/eval/specialSupervisorEval/all/info/get/weight', param, 'count')
    },
    //教学质量各个老师汇总
    qualityscoreyearallinfo: param => {
        return http.get('/tch/quality/score/year/all/info', param, 'count')
    },
    //督导专项各个老师汇总
    specialSupervisorEvalallinfo: param => {
        return http.get('/eval/specialSupervisorEval/all/info', param, 'count')
    },
    // 查询 教学质量评价各教师得分汇总
    getTeacherSummaryinfo: param => {
        return http.get('/tch/quality/score/all/info', param, 'count')
    },
    //4.6 开课部门统计
    getEvalGiveCourseOrgInfo: param => {
        return http.get('/tch/quality/score/getEvalGiveCourseOrgInfo', param, 'count')
    },
    // 查询 听评课汇总
    getTpkSummary: param => {
        return http.get('/tch/quality/score/collect/info', param, 'count')
    },
    //4.4.0 - 教学质量评价情况汇总-各院系统计
    getTpkSummaryOrg: param => {
        return http.get('/tch/quality/score/collect/org', param, 'count')
    },
    //4.5 （学年）教学质量评价情况汇总 - 总计
    collectYearInfo: param => {
        return http.get('/tch/quality/score/collect/year/info', param, 'count')
    },

    collectYearOrg: param => {
        return http.get('/tch/quality/score/collect/year/org', param, 'count')
    },
    //4.6 开课部门统计-学年
    getEvalGiveCourseOrgInfoByYear: param => {
        return http.get('/tch/quality/score/getEvalGiveCourseOrgInfoByYear', param, 'count')
    },
    getTchQualityScoreExportTemplate: param => {
        return http.get('/tch/quality/score/export/template', param, 'count')
    },
    getTchQualityScoreYearExportTemplate: param => {
        return http.get('/tch/quality/score/year/export/template', param, 'count')
    },
    // 学生评教 （教师综合成绩纵向对比）
    getsEvalStuTchTchscore: param => {
        return http.get('/sEvalStuTchTchscore/portraitCompareList', param, 'count')
    },
    // 学生评教 多学期纵向对比分析-部门
    getTchEvalScoreStudentOrgTerm: param => {
        return http.get('/tch/eval/score/student/org/term', param, 'count')
    },
    // 学生评教 多学期纵向对比分析-课程类型
    getTchEvalScoreStudentCourseTypeTerm: param => {
        return http.get('/tch/eval/score/student/course_type/term', param, 'count')
    },
    // 学生评教 多学期纵向对比分析-教师类型
    getTchEvalScoreStudentTchTypeTerm: param => {
        return http.get('/tch/eval/score/student/tch_type/term', param, 'count')
    },
    //4.3.0 学生评教 评分分布
    evalStuScore: param => {
        return http.get('/tch/eval/score/student/score', param, 'count')
    },
    // 历年得分分布纵向对比分析
    // 查询 按部门(默认督导)
    getSDinfoByDepart: param => {
        return http.get('/tch/eval/score/supervisor/org/term', param, 'count')
    },
    // 查询 按课程类型(默认督导)
    getSDinfoByCourse: param => {
        return http.get('/tch/eval/score/supervisor/course_type/term', param, 'count')
    },
    // 查询 按教师类型(默认督导)
    getSDinfoByTeacher: param => {
        return http.get('/tch/eval/score/supervisor/tch_type/term', param, 'count')
    },
    // 领导评教 多学期纵向对比分析-部门
    getTchEvalScoreLeaderOrgTerm: param => {
        return http.get('/tch/eval/score/leader/org/term', param, 'count')
    },
    // 领导评教 多学期纵向对比分析-课程类型
    getTchEvalScoreLeaderCourseTypeTerm: param => {
        return http.get('/tch/eval/score/leader/course_type/term', param, 'count')
    },
    // 领导评教 多学期纵向对比分析-教师类型
    getTchEvalScoreLeaderTchTypeTerm: param => {
        return http.get('/tch/eval/score/leader/tch_type/term', param, 'count')
    },
    // 同行评教 多学期纵向对比分析-部门
    getTchEvalScoreCollegueOrgTerm: param => {
        return http.get('/tch/eval/score/colleague/org/term', param, 'count')
    },
    // 同行评教 多学期纵向对比分析-课程类型
    getTchEvalScoreColleagueCourseTypeTerm: param => {
        return http.get('/tch/eval/score/colleague/course_type/term', param, 'count')
    },
    // 同行评教 多学期纵向对比分析-教师类型
    getTchEvalScoreColleagueTchTypeTerm: param => {
        return http.get('/tch/eval/score/colleague/tch_type/term', param, 'count')
    },
    //4.3.0 教师评价明细
    evalTchDetail: param => {
        return http.get('/tch/quality/score/not/eval/teacher/detail', param, 'count')
    },
    //4.3.0 课程评价明细
    evalCourseDetail: param => {
        return http.get('/tch/quality/score/not/eval/course/detail', param, 'count')
    },
    //4.3.0 未被评价教师汇总
    notEvalTch: param => {
        return http.get('/tch/quality/score/not/eval/teacher', param, 'count')
    },
    //4.3.0 未评价课程汇总
    notEvalCourse: param => {
        return http.get('/tch/quality/score/not/eval/course', param, 'count')
    },
    //4.3.0 班级考勤详情
    attendClassSignIn: param => {
        return http.get('/attend/class/signIn', param, 'count')
    },
    //4.3.0 学生考勤详情
    attendStuSignIn: param => {
        return http.get('/attend/stu/signIn', param, 'count')
    },
    //督导/领导听评课进度
    getLeaderProgress: (param, isform) => {
        if (isform) {
            return http.qsPost('/taskProgress/leadersAndSupervisors', param, {}, 'count')
        } else {
            return http.get('/taskProgress/leadersAndSupervisors', param, 'count')
        }
    },
    //同行听课进度
    getColleagueProgress: (param, isform) => {
        if (isform) {
            return http.qsPost('/taskProgress/colleagues', param, {}, 'count')
        } else {
            return http.get('/taskProgress/colleagues', param, 'count')
        }
    },
    //听评课记录导出-查询已有评价记录的项目
    evaluateProject: param => {
        return http.get('/common/evaluateProject/content', param, 'count')
    },
    //督导听课记录
    getSupervisorContent: param => {
        return http.get('/supervisorEvaluationTeaching/content', param, 'count')
    },
    //领导听课记录
    getLeaderContent: param => {
        return http.get('/leaderEvaluationTeaching/content', param, 'count')
    },
    //同行听课记录
    getColleagueContent: param => {
        return http.get('/colleagueEvaluationTeaching/content', param, 'count')
    },
    //4.6.0 同行听课记录批量导出
    colleagueEvaluationTeachingBatchExport: param => {
        return http.get('/colleagueEvaluationTeaching/batchExport', param, 'count')
    },
    //4.6.0 督导听课记录批量导出
    supervisorEvaluationTeachingBatchExport: param => {
        return http.get('/supervisorEvaluationTeaching/batchExport', param, 'count')
    },
    //4.6.0 领导听课记录批量导出
    leaderEvaluationTeachingBatchExport: param => {
        return http.get('/leaderEvaluationTeaching/batchExport', param, 'count')
    },
    //同行听课记录导出
    getColleagueContentExport: param => {
        return http.get('/colleagueEvaluationTeaching/content/export', param, 'count')
    },
    //督导听课记录导出
    getSupervisorContentExport: param => {
        return http.get('/supervisorEvaluationTeaching/content/export', param, 'count')
    },
    //领导听课记录导出
    getLeaderContentExport: param => {
        return http.get('/leaderEvaluationTeaching/content/export', param, 'count')
    },
    //{evaluateCode}导出报告
    exportDocs: (evaluateCode, param) => {
        return http.get('/docs/' + evaluateCode, param, 'count')
    },
    // 预览文件
    showDoc: (evaluateCode, param) => {
        return http.get('/docs/show/' + evaluateCode, param, 'count')
    },
    postImportRecords: (data, param) => {
        return http.post('/impClassHourRecord/importRecords', data, param, 'count')
    },
    // 查询 各教师评价对比分析导出
    getTeacherSummaryExport: param => {
        return http.get('/tch/quality/score/portraitCompareList/info/export', param, 'count')
    },
    // 查询 各教师评价对比分析导出
    getTeacherSummaryExport: param => {
        return http.get('/tch/quality/score/portraitCompareList/info/export', param, 'count')
    },
    // 查询 各教师评价对比分析
    getTeacherSummary: param => {
        return http.get('/tch/quality/score/portraitCompareList/info', param, 'count')
    },
    // 教师总课时统计
    getImpClassHourRecord: param => {
        return http.get('/impClassHourRecord/list', param, 'count')
    },
    // 教师总课时统计
    getImpUserTotalClassHourr: param => {
        return http.get('/impUserTotalClassHour/list', param, 'count')
    },
    // 教学巡查记录
    getwATeachPatrolRecord: param => {
        return http.get('/wATeachPatrolRecord/teachPatrolRecordList', param, 'count')
    },
    //4.5 教师得分-教学班评分明细-评价详情
    allTeacherScoreInfo: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/scoreInfo', param, 'count')
    },
    //4.3.0 - 查看客观评价
    studentEvaluationTeachingGetObjectivities: param => {
        return http.get('/studentEvaluationTeaching/getObjectivities', param, 'count')
    },
    // 得分统计（领导评教、同行评教、督导评教）-导出主观评价
    getStudentEvaluationTachingAllTeacherExportSubjective: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/export/subjective', param, 'count')
    },
    //教师得分-教学班评分明细
    getStudentScoreDetail: param => {
        return http.get('/studentEvaluationTeaching/allTeacher/score', param, 'count')
    },
    //教师得分 - 查看详情
    getTchDetail: param => {
        return http.get('/common/tch/detail', param, 'count')
    },
    //课程得分 - 查看详情
    getCourseDetail: param => {
        return http.get('/common/course/detail', param, 'count')
    },
    //评价详情-按行政班
    getQuestionnairy: param => {
        return http.get('/evalDetail/questionnairyAvg', param, 'count')
    },
    //评价详情-按教学班
    getQuestionnairyAvg: param => {
        return http.get('/evalDetail/teachingClass/questionnairyAvg', param, 'count')
    },
    // 教师评学(按教师)-统计教师参评的教学班
    getsTchEvalPercent: param => {
        return http.get('/sEvalTchEvalPercent/evalTeachingClassPercentList', param, 'count')
    },
    getSEvalTchEvalClassScoreGetScoreLevel: param => {
        return http.get('/sEvalTchEvalClassScore/getScoreLevel', param, 'count')
    },
    postSEvalTchEvalClassScoreSaveScoreLevel: (data, param) => {
        return http.post('/sEvalTchEvalClassScore/saveScoreLevel', data, param, 'count')
    },
    // 教师评学参评率
    getsEvalTchEvalPercent: param => {
        return http.get('/sEvalTchEvalPercent/list', param, 'count')
    },
    // 教师评学(按教师)-列表导出
    exportlistByTeacher: (projectCode, param) => {
        return http.get(`/sEvalTchEvalPercent/exportTeacherEvalTeachingClassDetail/${projectCode}`, param, 'count')
    },
    // 教师评学(按教师)-列表
    getslistByTeacher: param => {
        return http.get('/sEvalTchEvalPercent/listByTeacher', param, 'count')
    },
    // 教师评学班级得分
    getsEvalTchEvalClassScore: param => {
        return http.get('/sEvalTchEvalClassScore/list', param, 'count')
    },
    //4.3.0 按教学班查询 -- 列表
    sEvalTchEvalClassScoreListTeachingClass: param => {
        return http.get('/sEvalTchEvalClassScore/list/teachingClass', param, 'count')
    },
    //教师评学得分分布
    getScoreSpread: param => {
        return http.get('/sEvalTchEvalScoreSpread/evalTchEvalScoreList', param, 'count')
    },
    //获取用户信息
    getusersInfo: (userCodes, param) => {
        return http.get(`/analysePoint/users/${userCodes}`, param, 'count')
    },
    //4.7.3 学生评教教师得分评价明细
    getevalDetailquestionnairy: param => {
        return http.get('/evalDetail/questionnairy', param, 'count')
    },
    //4.7.3 学生评教教师得分查看详情
    getEvaluationTeacher: param => {
        return http.get('/studentReporterEvaluationTeacher/getObjectivities', param, 'count')
    },
    //4.7.3 学生评教教师得分评价记录
    EvaluationevaluateRecodeList: param => {
        return http.get('/studentReporterEvaluationTeacher/evaluateRecodeList', param, 'count')
    },
    // 获取学年学期
    getTerm: param => {
        return http.get('/common/term/info', param, 'count')
    },
    // 获取教研室
    getTeacherTrsList: param => {
        return http.get('/teacherTrs/trsList', param, 'count')
    },
    getTeacherTrsRanking: param => {
        return http.get('/teacherTrs/getTeacherTrsRanking', param, 'count')
    },
    getTeacherDepRanking: param => {
        return http.get('/teacherDep/teacherDepRanking', param, 'count')
    },
    //全校概况
    getSchoolInfo: param => {
        return http.get('/stuEval/analyze/get/schoolInfo', param, 'count')
    },
    getStuEvalAnalyzeGetOrgInfo: param => {
        return http.get('/stuEval/analyze/get/orgInfo', param, 'count')
    },
    getStuEvalAnalyzeGetAdminInfo: param => {
        return http.get('/stuEval/analyze/get/adminInfo', param, 'count')
    },
    getStuEvalAnalyzeGetExternalInfo: param => {
        return http.get('/stuEval/analyze/get/externalInfo', param, 'count')
    },
    //全校概况 -- 查询分析条件
    getSchoolCond: param => {
        return http.get('/stuEval/analyze/get/schoolCond', param, 'count')
    },
    //新增分析条件
    addSchoolCond: (data, param) => {
        return http.post('/stuEval/analyze/add/schoolCond', data, param, 'count')
    },
    //导入评价数据
    evalHistoryImport: (data, param) => {
        return http.post('/eval/history/import', data, param, 'count')
    },
    //教师评学分析
    getTchEvalInfo: param => {
        return http.get('/stuEval/analyze/get/tchEvalInfo', param, 'count')
    },
    //历史评教成绩查询
    evalHistoryList: param => {
        return http.get('/eval/history/list', param, 'count')
    },
    //评价数据导出中心-列表
    evalDataExportTaskLogList: param => {
        return http.get('/evalProjectDataExportCenter/evalDataExportTaskLogList', param, 'count')
    },
    // 获取评价类型
    getEvaluateType: param => {
        return http.get('/common/evaluate-all/type', param, 'count')
    },
    //教师所在部门
    evalHistoryOrg: param => {
        return http.get('/eval/history/org', param, 'count')
    },
    //教师类型
    evalHistoryStaffType: param => {
        return http.get('/eval/history/staffType', param, 'count')
    },
    //删除导出任务记录
    deleteEvalDataExportTaskLog: (data, param) => {
        return http.post('/evalProjectDataExportCenter/deleteEvalDataExportTaskLog', data, param, 'count')
    },
    //学生评价各年级打分分析 - 本学期各年级学生打分分布
    relationCompareStuNowTermPer: param => {
        return http.get('/relationCompare/stu/nowTermPer', param, 'count')
    },
    //学生评价各年级打分分析 - 本学期各年级学生打分情况
    relationCompareStuNowTermScore: param => {
        return http.get('/relationCompare/stu/nowTermScore', param, 'count')
    },
    //4.3.0学生评价各年级打分分析 - 各年级历年打分情况
    relationCompareStuGradeScore: param => {
        return http.get('/relationCompare/stu/gradeScore', param, 'count')
    },
    //4.3.0学生评价有效性分析 - 相同评价明细
    relationCompareStuEffectDeatil: param => {
        return http.get('/relationCompare/stu/effectDetail', param, 'count')
    },
    //学生评价关联分析 - 各开课部门学生打分情况分析
    relationCompareStuCourseOrgAnalysis: param => {
        return http.get('/relationCompare/stu/courseOrgAnalysis', param, 'count')
    },
    //学生评价关联分析 - 各课程学生打分情况分析
    relationCompareStuCourseTypeAnalysis: param => {
        return http.get('/relationCompare/stu/courseTypeAnalysis', param, 'count')
    },
    //学生评价关联分析 - 学生主观评价词云
    relationCompareStuSubjectEval: param => {
        return http.get('/relationCompare/stu/subjectEval', param, 'count')
    },
    //学生评价有效性分析 - 对所有教师评价
    relationCompareStuEffectEval: param => {
        return http.get('/relationCompare/stu/effectEval', param, 'count')
    },
    //教师历年对比分析 - 学生评教单个指标对比 - 指标对比设置，获取默认指标设置（选项和下拉列表一次性反馈）
    relationCompareTchGetAllKpi: param => {
        return http.get('/relationCompare/tch/getAllKpi', param, 'count')
    },
    //4.3.0 -教师得分关联分析 - 教师信息、课程类型关联分析
    relationCompareTchScoreAnalysis: param => {
        return http.get('/relationCompare/tch/scoreAnalysis', param, 'count')
    },
    //4.3.0 -教师得分关联分析 - 同一班级评价教师课程关联分析、评价其他教师关联分析
    relationCompareTchClassEval: param => {
        return http.get('/relationCompare/tch/classEval', param, 'count')
    },
    //4.3.0 - 教师历年对比分析 -- 质量评价综合分对比、学生评教同课程得分对比
    relationCompareTchEveryYear: param => {
        return http.get('/relationCompare/tch/everyYear', param, 'count')
    },
    //4.6.0 - 教师课程得分汇总
    tchScoreSummary: param => {
        return http.get('/evalTchEvalScoreController/tchScoreSummary', param, 'count')
    },
    // 5.2.0-教师评学参评率（按教师）-导出未评价明细
    getExportUnEvaluatedDetail: param => {
        return http.get(`/sEvalTchEvalPercent/exportUnevaluatedDetail/${param.projectCode}/${param.termCode}`, param, 'count')
    },
    // 5.2.0-课程开课周次查询
    getCourseStartWeekListCourseStartWeek: param => {
        return http.get('/courseStartWeek/listCourseStartWeek', param)
    },
    // 5.2.0-学生评教得分汇总（按教师）
    getStudentEvaluationTeachingGetCollectInfoByTch: param => {
        return http.get('/studentEvaluationTeaching/getCollectInfoByTch', param, 'count')
    },
    // 5.2.0-根据身份查权限
    getApplicationTreeMenu: param => {
        return http.get('/applicationTreeMenu/applicationTreeMenuList', param)
    },
    // 5.2.0-查询用户是督导组长还是督导
    getIdentitiesLeaderByGroupMember: param => {
        return http.get('identities/leaderByGroupMember', param)
    },
    // 5.2.0-获取考试时间段-没有使用
    postPatrolExamTaskListExamTimeRange: (data, param) => {
        return http.post('/patrolExamTask/listExamTimeRange', data, param)
    },
    // 5.2.0-试巡查子任务-督导任务列表
    GET_PATROLEXAM_LISTEXAMINSPECTION: param => {
        return http.get('/patrolExam/listExamInspection', param)
    },
    // 获取楼栋巡查记录
    GET_PATROLEXAM_GETPATROLEXAMBUILDINGECORD: param => {
        return http.get(`/patrolExam/getPatrolExamBuildingRecord`, param)
    },
    // 获取巡查人列表
    GET_PATROLEXAM_BUILDINGPATROLUSERLIST_BYTASKCODE: params => {
        return http.get(`/patrolExam/buildingPatrolUserList/${params.taskCode}`, params)
    },
    // 提交楼栋巡查记录
    POST_PATROLEXAM_ADDPATROLEXAMBUILDING: (data, params) => {
        return http.post(`/patrolExam/addPatrolExamBuilding`, data, params)
    },
    // 获取教学秩序巡查记录
    GET_PATROLCOURSE_GETPATROLBUILDINGRECORD: params => {
        return http.get(`/patrolCourse/getPatrolBuildingRecord`, params)
    },
    // 获取教学秩序巡查巡查人列表
    GET_PATROLCOURSE_BUILDINGPATROLUSERLIST: params => {
        return http.get(`/patrolCourse/buildingPatrolUserList/${params.taskCode}`, params)
    },
    // 添加教学秩序巡查楼栋巡查记录
    POST_PATROLCOURSE_ADDPATROLBUILDINGRECORD: (data, params) => {
        return http.post(`/patrolCourse/addPatrolBuildingRecord`, data, params)
    },
    // 当前用户是否是管理员
    GET_ROLE_ISMANAGER: params => {
        return http.get(`/role/isManager`, params)
    },
    // 获取CAS认证地址
    GET_DEFAUTH_GETCASEADDRESS: params => {
        return http.get(`/defauth/getCasAddress/${params.sysCode}`, params)
    },
    // 5.2.0-获取考核听课、专项评价项目token
    GET_SPECIALEVALUATE_AUTHINFO: params => {
        return http.get(`/specialEvaluate/authInfo`, params)
    },
    // 新增获取学年
    getYearinfo: params => {
        return http.get(`/common/year/info`, params)
    },
    // 新增获取学年 - 只返回年份，而不是学期
    getListYear: params => {
        return http.get(`/common/year/listYear`, params, 'count')
    },
    // 获取班级
    getSquad: params => {
        return http.get('/common/class/info', params, 'count')
    },
    //获取听评课任务 --任务项
    getTasks: params => {
        return http.get('/taskProgress/tasks', params, 'count')
    },
    // 获取被评价类型
    dictionary: params => {
        return http.get(`/dictionary/${params.dictionaryCategoryValue}`, params, 'count')
    },
    // 教师自评项目-列表
    GET_SELF_EVALUATE_TEACHER_PROJECT_LIST: params => {
        return http.get(`/selfEvaluateTeacher/selfEvaluateTeacherProjectList`, params)
    },
    // 5.2.0-教师自评项目-详情
    GET_SELF_EVALUATE_TEACHER_INFO: param => {
        return http.get(`/selfEvaluateTeacher/get/info`, param)
    },
    // 5.2.0-教师自评项目-提交
    POST_SELF_EVALUATE_EVALUATE: (param, param2) => {
        return http.post(`/selfEvaluateTeacher/evaluate`, param, param2)
    },
    // 5.2.0-教师自评项目-查看结果
    GET_SELF_EVALUATE_TEACHER_EVAL_INFO: param => {
        return http.get(`/selfEvaluateTeacher/evalinfo`, param)
    },
    // 教师评学定性分析-词云
    GET_TEACHINGEVALUATESTUDENT_SUBJECTEVAL: params => {
        return http.get(`/teachingEvaluateStudent/subjectEval`, params, 'count')
    },
    // 4.7.1--通过课程明细code获取直播地址-理工-智园监控对接
    GET_LIVESTREAM_GETLIVESTREAMURL: param => {
        return http.get(`/liveStream/getLiveStreamUrl/${param.courseTimetableDetailCode}`, param)
    },
    // fileUpload
    POST_FILEUPLOAD: formData => {
        return http.qsPost(`/fileUpload`, formData, undefined, undefined, true)
    },
    // 4.7.1-新增--用于获取系统配置，判断在课堂监控页面是否展示评价按钮
    // getSystemConfig: (param) => {
    //   return http.get(`/common/getSystemConfig`, param);
    // },
    GET_STUDENTEVALUATE_COURSE_LIST: params => {
        return http.get(`/studentevaluate/courses/list`, params)
    },
    GET_STUDENTEVALUATE_COURSEDETAILS4NOTEND: params => {
        return http.get(`/studentevaluate/coursedetails4notend`, params)
    },
    GET_STUDENTEVALUATE_CHECKCOURSESTATE: params => {
        return http.get(`/studentevaluate/checkCourseState`, params)
    },
    GET_STUDENTEVALUATE_QUESTIONNAIRES: params => {
        return http.get(`/studentevaluate/questionnaires`, params)
    },
    PUT_STUDENTEVALUATE_QUESTIONNAIRES: (data, params) => {
        return http.post(`/studentevaluate/put/questionnaires`, data, params)
    },
    GET_STUDENTEVALUATE_COURSEDETAILS4END: params => {
        return http.get(`/studentevaluate/coursedetails4end`, params)
    },
    // 教师问卷-添加-5.3.0
    POST_TEACHERQUESTIONNAIRE_ADD: data => {
        return http.post(`/teacherQuestionnaire/add`, data)
    },
    // 教师问卷-列表-5.3.0
    GET_TEACHERRQUESTIONNAIRE_LIST: params => {
        return http.get(`/teacherQuestionnaire/list`, params)
    },
    // 教师问卷-获取问卷明细-5.3.0
    GET_TEACHERQUESTIONNAIRE_QUESTIONNAIREINFO: params => {
        return http.get(`/teacherQuestionnaire/getQuestionnaireInfo/${params.questionnaireCode}`, params)
    },
    // 教师问卷-修改问卷-5.3.0
    POST_TEACHERQUESTIONNAIRE_UPDATE: data => {
        return http.post(`/teacherQuestionnaire/update/${data.questionnaireCode}`, data)
    },
    // 教师问卷-修改问卷状态-5.3.0
    POST_TEACHERQUESTIONNAIRE_QUESTIONNAIRECODE: data => {
        return http.post(`/teacherQuestionnaire/questionnaireCode/${data.questionnaireCode}/${data.questionnaireStatus}`, data)
    },
    // 教师问卷-删除问卷-5.3.0
    POST_TEACHERQUESTIONNAIRE_DELETE: data => {
        return http.post(`/teacherQuestionnaire/delete/${data.questionnaireCode}`, data)
    },
    // 教师问卷-复制问卷-5.3.0
    POST_TEACHERQUESTIONNAIRE_COPY: data => {
        return http.post(`/teacherQuestionnaire/copy/${data.questionnaireCode}`, data)
    },
    // 教师问卷-导入题目-查询指标分类-之前课堂互动移动端的接口
    GET_QUESTIONNAIRE_ALLKPICLASSFY: params => {
        return http.get(`/questionaire/allKpiClassfy`, params)
    },
    // 教师问卷-导入题目-查询指标分类下的指标列表-之前课堂互动移动端的接口
    GET_QUESTIONNAIRE_OBJECTIVITYKPILIST: params => {
        return http.get(`/questionaire/objectivityKpiList`, params)
    },
    // 教师问卷-查看问卷结果-5.3.0
    GET_TEACHERQUESTIONNAIRE_RESULT: params => {
        return http.get(`/teacherQuestionnaire/result/${params.questionnaireCode}`, params)
    },
    // 教师问卷-导出明细-5.3.0
    GET_TEACHERQUESTIONNAIRE_RESULT_EXPORT: params => {
        return http.get(`/teacherQuestionnaire/result/excel/export/${params.questionnaireCode}`, params)
    },
    // 教师问卷-获取发放问卷地址-5.3.0
    GET_TEACHERQUESTIONNAIRE_URL: params => {
        return http.get(`/teacherQuestionnaire/url/${params.questionnaireCode}`, params)
    },
    // 教学督导工作记录表-列表-5.3.0
    GET_SUPERVISORWORKRECORD_LIST: params => {
        return http.get(`/supervisorWorkRecord/list`, params)
    },
    // 教学督导工作记录表-新增/编辑-5.3.0
    POST_SUPERVISORWORKRECORD_ADDORUPDATE: data => {
        return http.post(`/supervisorWorkRecord/addOrUpdate`, data)
    },
    // 教学督导工作记录表-查询-5.3.0
    GET_SUPERVISORWORKRECORD: params => {
        return http.get(`/supervisorWorkRecord/${params.code}`, params)
    },
    // 教学督导工作记录表-删除-5.3.0
    POST_SUPERVISORWORKRECORD_DELETE: data => {
        return http.post(`/supervisorWorkRecord/delete/${data.code}`, data)
    },
    // 教师问卷-检查用户是否提交-5.3.0
    GET_TEACHER_QUESTIONNAIRE_CHECK_SUBMIT: params => {
        return http.get(`/teacherQuestionnaire/checkSubmit/${params.questionnaireCode}`, params)
    },
    // 教师问卷-获取问卷明细-5.3.0
    GET_TEACHER_QUESTIONNAIRE_QUESTIONNAIRE_INFO: params => {
        return http.get(`/teacherQuestionnaire/getQuestionnaireInfo/${params.questionnaireCode}`, params)
    },
    // 教师问卷-提交问卷-5.3.0
    POST_TEACHER_QUESTIONNAIRE_SUBMIT: data => {
        return http.post(`/teacherQuestionnaire/submit`, data)
    },
    // 个人中心-我收到的评价-提交教学改进报告-5.3.0
    POST_RECEIVEEVALUATE_IMPROVEREPORTCONTENT: data => {
        return http.post(`/receiveevaluate/improveReportContent/${data.evaluateCode}`, data)
    },
    // 督导工作记录表汇总-5.3.0
    GET_SUPERVISOR_WORK_RECORD_LIST: param => {
        return http.get(`/supervisorWorkRecord/list`, param, 'count')
    },
    // 教学督导工作记录表汇总-查询-5.3.0
    GET_SUPERVISOR_WORK_RECORD: params => {
        return http.get(`/supervisorWorkRecord/${params.code}`, params, 'count')
    },
    // 教师改进报告列表-5.3.0
    GET_IMPROVE_LIST: params => {
        return http.get(`/teacherImproveReport/improveList`, params, 'count')
    },
    // 教师改进报告明细列表-5.3.0
    GET_IMPROVE_DETAIL: params => {
        return http.get(`/teacherImproveReport/getImproveDetail`, params, 'count')
    },
    // 教师自评报告列表-5.3.0
    GET_TEACHER_SELF_EVAL_LIST: params => {
        return http.get(`/teacherSelfEval/list`, params, 'count')
    },
    // 教师自评报告评价明细-5.3.0
    GET_TEACHER_SELF_EVAL_EVALUATE_INFO: params => {
        return http.get(`/teacherSelfEval/evaluateInfo`, params, 'count')
    },
    // 获取登录人-用户信息-5.2.0
    GET_AUTHUSER_INFO: param => {
        return http.get(`/authUser/info`, param)
    },
    // 5.3.1-0 获取系统配置
    GET_CONFIG_SETTING_MAP: params => {
        return requestData(`/configSetting/getConfigSettingMap`, { params, noAuth: true }, 'get')
    },
    // 5.0.0-0-导出评价明细（信息员评价教师得分、信息员评价课程得分）
    GET_STUDENTREPORTEREVALUTIONTEACHER_EXPORT_EVALUATE_DETAIL: param => {
        return http.get(`/studentReporterEvaluationTeacher/export/evaluate/detail`, param, 'count')
    },
    // 5.4.0-非教务课程评价 - 评价记录
    GET_EVALUATERECORD_LIST: params => {
        return http.get(`/specialSuperAttendALectureTask/evaluateRecordList`, params)
    },
    // 5.4.0 非教务课程评价 - 获取评价明细
    GET_EVALUATERECORD_EVALUATEINFO: params => {
        return http.get(`/specialSuperAttendALectureTask/getEvaluateInfo/${params.taskCode}`, params)
    },
    // 5.4.0 - 非教务课程评价 - 提交评价
    POST_EVALUATERECORD_ADDEVALUATE: (param, param2) => {
        return http.post(`/specialSuperAttendALectureTask/evaluate/${param2.taskCode}`, param, param2)
    },
    // 5.4.0 - 非教务课程评价 - 修改评价
    POST_EVALUATERECORD_UPDATEEVALUATE: (param, param2) => {
        return http.post(`/specialSuperAttendALectureTask/updateEvaluate/${param2.evaluateCode}`, param, param2)
    },
    // 5.4.0 - 分析报告管理 - 报告列表
    GET_REPORTMANAGER_REPORTLIST: params => {
        return http.get(`/reportManager/reportList`, params, 'count')
    },
    // 5.4.0 - 分析报告管理 - 添加报告
    POST_REPORTMANAGER_ADD: (data, param) => {
        return http.post(`/reportManager/add`, data, param, 'count')
    },
    // 5.4.0 - 分析报告管理 - 删除报告
    POST_REPORTMANAGER_DEL: (data, param) => {
        return http.post(`/reportManager/delReport/${data.reportId}`, data, param, 'count')
    },
    // 5.4.0 - 分析报告管理 - 通过教学班数据获取的开课部门列表
    GET_REPORTMANAGER_COURSEORGLIST: params => {
        return http.get(`/reportManager/courseOrgList`, params, 'count')
    },
    // 5.4.0 - 分析报告管理 - 专业列表
    GET_REPORTMANAGER_MAJORLIST: params => {
        return http.get(`/reportManager/majorList`, params, 'count')
    },
    // 5.4.0 - 分析报告管理 - 教师列表
    GET_REPORTMANAGER_TEACHERLIST: params => {
        return http.get(`/reportManager/teacherList`, params, 'count')
    },
    // 5.4.0 - 分析报告管理 - 下发/教师列表
    GET_REPORTMANAGER_ISSUETEACHERLIST: params => {
        return http.get(`/reportManager/issueTeacherList/${params.reportId}`, params, 'count')
    },
    // 5.4.0 - 分析报告管理 - 下发
    POST_REPORTMANAGER_ISSUE: (data, param) => {
        return http.post(`/reportManager/issue/${data.reportId}`, data, param, 'count')
    },
    // 5.4.0 - 分析报告管理 - 批量下发
    POST_REPORTMANAGER_BATCHISSUE: (data, param) => {
        return http.post(`/reportManager/batchIssue`, data, param, 'count')
    },
    // 5.4.0 - 质量分析报告 - 修改ai回复
    POST_REPORTMANAGER_UPDATEAIREPLY: (data, param) => {
        return http.post(`/reportManager/updateAiReply`, data, param, 'count')
    },
    // 5.4.0 - 分析报告管理 - AI 对话
    POST_RCHAT: (data, param) => {
        return http.post(`/chat`, data, param, 'count', 300000)
    },
    // 5.4.0 - 学校教学质量分析 - 查看报告
    GET_SCHOOL_TEACHING_QUALITY_REPORT: params => {
        return http.get(`/schoolTeachingQualityReport/get/${params.reportId}`, params, 'count')
    },
    // 5.4.0 - 开课部门教学质量分析 - 查看报告
    GET_COURSE_ORG_TEACHING_QUALITY_REPORT: params => {
        return http.get(`/courseOrgTeachingQualityReport/get/${params.reportId}`, params, 'count')
    },
    // 5.4.0 - 专业教学质量分析 - 查看报告
    GET_MAJOR_TEACHING_QUALITY_REPORT: params => {
        return http.get(`/majorTeachingQualityReport/get/${params.reportId}`, params, 'count')
    },
    // 5.4.0 - 教师教学质量分析 - 查看报告
    GET_TCH_TEACHING_QUALITY_REPORT: params => {
        return http.get(`/tchTeachingQualityReport/get/${params.reportId}`, params, 'count')
    },
    // 5.4.0 - 质量分析报告 - 报告列表
    GET_ANALYSISREPORT_LIST: params => {
        return http.get(`/analysisReport/list`, params)
    },
    // 5.4.0 - 质量分析报告 - 反馈
    POST_ANALYSISREPORT_UPDATEREPORTFEEDBACK: (data, param) => {
        return http.post(`/analysisReport/updateAnalysisReportFeedback`, data, param)
    },
    // 5.4.0 - 质量分析报告 - 报告详情
    GET_ANALYSISREPORT_DETAIL: params => {
        return http.get(`/analysisReport/get/${params.reportId}`, params)
    },
    // 5.4.0 - 质量分析报告 - 反馈检查是否其他老师也在处理
    POST_ANALYSISREPORT_FEEDBACKHANDLE: (data, param) => {
        return http.post(`/analysisReport/feedbackHandle/${data.reportId}`, data, param)
    },
    // 5.4.0 - 质量分析报告 - 数据截止时间
    GET_ANALYSISREPORT_DEADLINE: params => {
        return http.get(`/reportManager/getDeadline`, params, 'count')
    }
}
export default api
export const outLogin = api.outLogin
export const getCas = api.GET_DEFAUTH_GETCASEADDRESS



// WEBPACK FOOTER //
// ./src/api/all.js